/* @ngInject */
function wideService () {
  var service = {
    getWideEmail,
    getMessageTemplate,
    shouldShowSendToWideButton
  }

  function getWideEmail () {
    return 'suporte_vibra@widedigital.com.br'
  }

  function getMessageTemplate (code) {
    if (!code) {
      code = '<strong>[escreva aqui]</strong>'
    }

    return `<div><!--block-->Solicito que esse material seja enviado para meu painel de LED. Informações:</div><div><!--block--><br>Data de <strong>início</strong> de veiculação do material: <strong>[escreva aqui]</strong><br>Data de <strong>final</strong> de veiculação do material: <strong>[escreva aqui]</strong></div><div><!--block--><br>Código SAP = ${code}</div>`
  }

  function shouldShowSendToWideButton (template) {
    const validFormatIds = [7597, 17779, 20266]
    if (validFormatIds.includes(template.productId)) {
      return true
    }
    return false
  }

  return service
}

export { wideService }
